import React from 'react';
import axios from 'axios';
import { Button, Card, Space } from 'antd';
import { AuthApi } from '../../../services/Api';
import { encrypUtil } from '../../../utils/EncrypUtil';

interface PanelTestProps {
    trans: (key: string) => string;
}

interface PanelTestState {
    encodeLoading: boolean;
    decodeLoading: boolean;
}

export default class PanelTest extends React.Component<PanelTestProps, PanelTestState> {
    state: PanelTestState = {
        encodeLoading: false,
        decodeLoading: false,
    };

    callEncodeTest = async () => {
        const DEBUG = true;
        const TAG = 'PanelTest.callEncodeTest() - ';
        DEBUG && console.log(TAG, 'CALL callEncodeTest');

        this.setState({ encodeLoading: true });
        try {
            const lang = localStorage.getItem('lang') || 'zh_CN';
            let requestData = { lang: lang.split('_')[0] };
            requestData = await encrypUtil.encodeRequestRsa(requestData);
            DEBUG && console.log(TAG, 'requestData:\n', requestData);
            const response = await axios.post(AuthApi.ENCODE_TEST, requestData);
            DEBUG && console.log(TAG, response.data);
        } finally {
            this.setState({ encodeLoading: false });
        }
    };

    callDecodeTest = async () => {
        const DEBUG = true;
        const TAG = 'PanelTest.callDecodeTest() - ';
        DEBUG && console.log(TAG, 'CALL callDecodeTest');

        this.setState({ decodeLoading: true });
        try {
            const lang = localStorage.getItem('lang') || 'zh_CN';
            const requestData = { lang: lang.split('_')[0] };
            const response = await axios.post(AuthApi.DECODE_TEST, requestData);
            DEBUG && console.log(TAG, response.data);
        } finally {
            this.setState({ decodeLoading: false });
        }
    };

    render() {
        const { trans: t } = this.props;
        const { encodeLoading, decodeLoading } = this.state;

        return (
            <Card title={t('testPanel')}>
                <Space wrap>
                    <Button type="primary" loading={encodeLoading} onClick={this.callEncodeTest}>
                        {t('callEncodeTest')}
                    </Button>
                    <Button loading={decodeLoading} onClick={this.callDecodeTest}>
                        {t('callDecodeTest')}
                    </Button>
                </Space>
            </Card>
        );
    }
}
